import { Box, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLang } from "../../../../Hooks";
import { AnalyticalLayerNode } from "./AnalyticalLayerNode";

export const AnalyticalLayersTree = ({ data }) => {
  const { texts, lang } = useLang();
  const [treeData, setTreeData] = useState([]);
  const isArabic = lang === "ar";

  useEffect(() => {
    setTreeData(data?.treeData ? [...data.treeData] : []);
  }, [data]);

  const handleToggle = (nodeId) => {
    const toggleNode = (nodes) =>
      nodes.map((node) => ({
        ...node,
        isOpen: node.id === nodeId ? !node.isOpen : node.isOpen,
        children: node.children ? toggleNode(node.children) : node.children,
      }));

    setTreeData((current) => toggleNode(current));
  };

  if (!data?.headers?.length || treeData.length === 0) {
    return (
      <Flex justify="center" align="center" h="100%">
        <Text>{texts.reports?.loadingReportData || "Loading report data..."}</Text>
      </Flex>
    );
  }

  return (
    <Box
      bg="white"
      border="1px solid #eaeef2"
      borderRadius="lg"
      boxShadow="sm"
      h="100%"
      position="relative"
    >
      <Box inset="0" overflow="auto" position="absolute">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f5f7fa", position: "sticky", top: 0, zIndex: 2 }}>
              <th style={{ minWidth: "300px", padding: "8px 6px", textAlign: isArabic ? "right" : "left" }}>
                {data.headers[0] || "ACCOUNT"}
              </th>
              <th style={{ padding: "8px 6px", textAlign: isArabic ? "left" : "right" }}>
                {data.headers[1] || "VALUE"}
              </th>
              <th style={{ padding: "8px 6px", textAlign: isArabic ? "left" : "right" }}>
                {data.headers[2] || "%"}
              </th>
              <th style={{ padding: "8px 6px", textAlign: isArabic ? "left" : "right" }}>
                {data.headers[3] || "DETAILS"}
              </th>
            </tr>
          </thead>
          <tbody>
            {treeData.map((node) => (
              <AnalyticalLayerNode
                key={node.id}
                isArabic={isArabic}
                node={node}
                onToggle={handleToggle}
              />
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
};
